var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('img',{attrs:{"src":"https://images.zhibo.tv/2021/0406/upload.png","alt":""}})])
}]

export { render, staticRenderFns }